export default __webpack_public_path__ + "static/guide-icon-747630aaa2920ceb71f13cee7bb0bd93.png";